<template>
  <div
    class="main">
    <p
      class="ljb-item_cell item"
      @click="chooseFn">
      <span class="left ">{{ item.type }}</span>
      <span
        :class="{nextArrow:item.showNextArrow,priceClass:item.isPrice}"
        class="right ">{{ item.value }}</span>
    </p>

  </div>
</template>

<script>
export default {
  name: 'LjbItem',
  props: {
    item: {
      type: Object,
      default: function () {
        return ''
      }
    }
  },
  methods: {
    chooseFn () {
      this.$emit('chooseFn')
    }
  }
}
</script>

<style lang="scss" scoped>
  .main {
    background: #fff;
    padding: 7.5px $padding;
  }

  .item {
    justify-content: flex-start;
  }

  .no-border {
    border: none;
  }

  .left {
    font-size: 15px;
    color: $hint-color;
    line-height: 15px;
  }
  .right {
    margin-left: auto;
    font-size: 15px;
    color: $title-color;
    line-height: 15px;
    display: inline-block;

    &.nextArrow {
      background: url('https://cdn.51ljb.cn/ljb-arrow_next.png') no-repeat right;
      background-size: 6px 10px;
      padding-right: 11px;
    }
  }
  .priceClass{
    color: $price-color;
  }
</style>



// WEBPACK FOOTER //
// src/components/LjbLeftItem.vue